import { createCustomEnum } from "./customEnum";

export type TerminalSolutionStatusKeys = "Complete" | "Draft" | "Pending";

const TerminalSolutionStatus = createCustomEnum({
	Complete: { name: "Complete", value: "complete", displayName: "Complete" },
	Draft: { name: "Draft", value: "draft", displayName: "Draft" },
	Pending: { name: "Pending", value: "pending", displayName: "Pending" },
});

export default TerminalSolutionStatus;
